import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { OSUpdate as MdmOsUpdate } from '@rocksoft/mdm-sdk-v2';
import type { LocationAllowedOsUpdate } from '../../types/location-allowed-os-update.types';
import { OsUpdateListItemComponent } from '../os-update-list-item/os-update-list-item.component';

@Component({
  selector: 'era-os-update-list',
  templateUrl: './os-update-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [OsUpdateListItemComponent],
})
export class OsUpdateListComponent {
  readonly isEditing = input(false);
  readonly allowEditing = input(false);
  readonly allowSelecting = input(false);
  readonly osupdates = input<(MdmOsUpdate | LocationAllowedOsUpdate)[]>([]);

  readonly deleted = output<MdmOsUpdate | LocationAllowedOsUpdate>();
  readonly selectedOsUpdateChange = output<MdmOsUpdate | LocationAllowedOsUpdate>();

  public selectedOsUpdate: MdmOsUpdate | LocationAllowedOsUpdate;

  public delete(osupdate: MdmOsUpdate | LocationAllowedOsUpdate) {
    this.deleted.emit(osupdate);
  }

  public select(selectedOsUpdate: MdmOsUpdate | LocationAllowedOsUpdate) {
    if (this.selectedOsUpdate !== selectedOsUpdate) {
      this.selectedOsUpdate = selectedOsUpdate;
      this.selectedOsUpdateChange.emit(this.selectedOsUpdate);
    }
  }
}
